import React from "react";

import useAuthStore from "stores/authStore";
import { queryClient } from "./config";
import router from "./router";
import { RouterProvider } from "@tanstack/react-router";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";

function AppContent() {
  const auth = useAuthStore();

  return (
    <>
      <RouterProvider router={router} context={{ auth, queryClient }} />
      <ReactQueryDevtools initialIsOpen={false} />
    </>
  );
}
function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AppContent />
    </QueryClientProvider>
  );
}

export default App;
